module.exports = __webpack_public_path__ + "static/media/california-sheephead.fef356bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/california-sheephead.png
// module id = 306
// module chunks = 0